<template>
    <div class="  con_content">
        <div class="container">
            <div class="container_top h_48">
                纪念堂管理
               
            </div>     
            <div >
                
                <!-- table组件 -->
                <div class="my_table">
                    
                    <div class="my_search">
                        
                        <Row class="search_row">  
                            <div  class="search_name">
                         
                                <div class="lft mR10">所属类目 : &nbsp;</div> 
                                <div class="lft pointer"  :class="[title_num == -2 ?'colorP':'']"  @click="title_num = -2;guid = null"   > 全部 </div>
                                <div class="lft pointer"  :class="[title_num == -1 ?'colorP':'']"  @click="title_num = -1;guid = 'better'"   > &nbsp; <span class="cBlack">/</span>  &nbsp;推荐 </div>
                                <div class="lft pointer" v-for="(item,num) in titles" :class="[title_num == num?'colorP':'']"  @click="title_num = num;guid = item.guid" :key="num"> &nbsp; <span class="cBlack">/</span> &nbsp;{{item.title}} </div>
                                
                                                
                            </div> 
                             
                            <Button class="rgt mR20 top14" @click="route='/layout/circle/memorial/add';my_guid = $store.state.guid;lm_check='sj';out_btnFun(null,0)"  type="info">添加事件</Button> 
                            <Button class="rgt mR20 top14" @click="route='/layout/circle/memorial/add';my_guid = $store.state.guid;lm_check='rw';out_btnFun(null,0)"  type="info">添加人物</Button> 
                            <Button class="rgt mR20 top14" @click="lookFun"  type="info">查看类目</Button>   
                        </Row>        
                    </div>
                  
                </div>
                <div class="my_table">
                    
                    <div class="my_search" >
                        
                        <Row class="search_row">  
                            <div  class="search_name">
                         
                                <div class="lft mR10 fw900 fon fs18">纪念堂列表 </div> 
                                       
                            </div> 
                            <Col span="4" class="listIpt rgt mR20">
                                <Input  ref='isFocuseA'    :maxlength='20' @keyup.enter.native="nameFun" v-model="name"  class='ipt   top13 '  placeholder="请输入纪念堂名称"  >
                                    <Button size="small" @click='nameFun'   slot="append" icon="md-search"></Button>
                                </Input>
                            </Col>
                            
                        </Row>        
                    </div>
                  
                    <Table     border :columns="columns1" :data="data1" ref='table' >
                 
                        <!-- 推荐排序 -->
                        <template slot-scope="{ row, index }" slot="betterSort" >
                            <Input style="top:-0.5px"   v-model="row.betterSort" @keyup.enter.native="better_sortFun(row)"   type='number' class="ipt"  placeholder="推荐排序"  >
                                <Button size="small" @click='better_sortFun(row)'   slot="append" icon="md-create"></Button>
                            </Input>
                        </template>                      
                        <!-- 头像 -->
                        <template slot-scope="{ row, index }" slot="image" >
                            <div class="demo-avatar" >
                                <!-- <Avatar v-if="row.image == null" icon="ios-person" size="large" />
                                <Avatar v-else  :src="row.image" size="large"/>  -->

                                
                                
                                <img  v-if="!row.image"  src="../../../../public/images/head_mr.jpeg" class="tx_pic" size="large" /> 
                                <img  v-if="row.image"   :src="row.image" class="tx_pic" size="large" /> 
                            </div>  
                        </template>                      
                        <template slot-scope="{ row, index }" slot="btn" >
                 
                            <span  >
                                <Poptip trigger="hover"   content="查看">
                                    <Button  class="padlr5" size="small"  @click='lookj = true;lookj_val = row;out_btnFun2(row)'  type="info"      icon="md-search"></Button>
                                </Poptip>
                                <Poptip trigger="hover"   content="编辑">
                                    <Button class="padlr5" size="small"  @click='route="/layout/circle/memorial/editor";out_btnFun(row,1)'  type="success"      icon="md-open"></Button>
                                </Poptip>
                                <Poptip trigger="hover"  content="删除">
                                    <Button class="padlr5"  size="small" @click='route="/layout/circle/memorial/del";out_btnFun(row,2)'  type="error"      icon="md-close"></Button>
                                </Poptip>
                            </span>

                        </template>                      
                          
                    </Table>
                    <Footer>
                       <Page  :current.sync="page" :total="total" :page-size='size'    @on-change='change_page' @on-page-size-change='change_size' show-total  show-sizer      />
                    </Footer>
                    
                </div>
            </div>
        </div>

        <!-- 添加纪念堂,编辑纪念堂,删除纪念堂 -->
        <Modal
            v-model="out_btn"
            :title="out_title"
            
            class-name="vertical-center-modal"
            width="820"
        >
            <div slot="footer">
                <Button type='text'  @click='out_btnFail'>取消</Button>
                <Button type='primary'  @click='out_btnSucc'>{{out_succ}}</Button>
            </div>
            
            <p  v-if="out_btn_num == 2&&lm_check=='rw'">确定删除人物吗?</p>
            <p  v-if="out_btn_num == 2&&lm_check=='sj'">确定删除事件吗?</p>

            <ul class="layout_ul" v-if="out_btn_num != 2 ">
                <!-- 姓名 -->
                <li>
                    <div class='list_title' v-if="lm_check == 'rw'"> <span v-if="out_btn_num == 0" class="cRed">*</span> 姓名 :</div>                  
                    <div class="list_con" v-if="lm_check == 'rw'">
                        <Input   v-model="out_model1"   type='text' class="ipt"  placeholder="请输入姓名"    />
                    </div> 

                    <!-- 事件名称 -->
                    <div class='list_title' v-if="lm_check == 'sj'"> <span v-if="out_btn_num == 0" class="cRed">*</span> 事件名称 :</div>                                           
                    <div class="list_con" v-if="lm_check == 'sj'">
                        <Input   v-model="out_model1"   type='text' class="ipt"  placeholder="请输入事件名称"    />
                    </div>                                            
                </li>
                <!-- 多选 -->
                <li v-if="lm_check == 'rw'">
                    <div class='list_title'> <span v-if="out_btn_num == 0" class="cRed">*</span> 所属类目 :</div> 
                    <div class="list_con padt2">
                        
                        <CheckboxGroup v-model="out_model2" class="top4" >
                            <Checkbox   v-for="(item,num) in data" v-if="item.title != '事件'"  :label="item.guid" :key="num">
                                <span>{{item.title}}</span>
                            </Checkbox>
                        </CheckboxGroup>
                    </div>                                            
                </li>
                <!-- 性别 -->
                <li v-if="lm_check == 'rw'">
                    <div class='list_title'> <span v-if="out_btn_num == 0"  class="cRed">*</span> 性别 :</div> 
                    <div class="list_con lh20" >
                       
                        <RadioGroup v-model="sex" class="top5" >
                            <Radio    label="1" >      
                                <span>男</span>
                            </Radio>
                            <Radio    label="2" >      
                                <span>女</span>
                            </Radio>
                            <Radio    label="0" >      
                                <span>未知</span>
                            </Radio>
                            
                        </RadioGroup>
                    </div>                                            
                </li>
                <!-- 出生时间 -->
                <li>
                    <div class='list_title' v-if="lm_check == 'rw'"> <span v-if="out_btn_num == 0" class="cRed">*</span> 出生时间 :</div>  
                    <div class="list_con"   v-if="lm_check == 'rw'">
                       
                        <!-- 出生时间  -->
                        <Input   style="width: 180px"    v-model="start_time"  type="text" placeholder="公元前/189/2/15/农历" ></Input>
                        <!-- 死亡时间  -->
                        <Input   class="rgt"       style="width: 180px"    v-model="end_time"  type="text" placeholder="公元前/189/2/15/农历" ></Input>
                        <p class="rgt  fs14 rtxt"  > 死亡时间 :</p>
                    </div>  

                    <div class='list_title' v-if="lm_check == 'sj'"> <span v-if="out_btn_num == 0" class="cRed">*</span> 发生时间 :</div>  
                    <div class="list_con"  v-if="lm_check == 'sj'">
                        <!-- 出生时间  -->
                        <!-- <DatePicker format="yyyy-MM-dd"  style="width: 125px"   @on-change='start_timeFun' v-model="start_time"  type="date" placeholder="生于" ></DatePicker> -->
                        <!-- 死亡时间  -->
                        <!-- <DatePicker format="yyyy-MM-dd"  class="rgt" style="width: 125px"   @on-change='end_timeFun' v-model="end_time"  type="date" placeholder="卒于" ></DatePicker> -->
                        <!-- <p class="rgt  fs14" style="height:32px;line-height:32px;padding-right:10px">死亡时间 :</p> -->
                     
                        <!-- 发生时间  -->
                        <Input class="mR20"  style="width: 180px"    v-model="start_time"  type="text"  placeholder="请输入发生时间" ></Input>  <span class="cRed">*例如：1997-07-01</span>
                        
                    </div>                                            
                </li>
                <!-- 出生地 -->
                <li>
                    <div class='list_title' v-if="lm_check == 'rw'"> <span v-if="out_btn_num == 0" class="cRed">*</span> 出生地 :</div> 
                    <div class="list_con"   v-if="lm_check == 'rw'">
                        <Input  show-word-limit  v-model="start_place"   type='text' class="ipt"  placeholder="请输入出生地"    />
                    </div>  

                    <!-- 发生地址    -->
                    <div class='list_title' v-if="lm_check == 'sj'"> <span v-if="out_btn_num == 0" class="cRed">*</span> 发生地址 :</div> 
                    <div class="list_con"   v-if="lm_check == 'sj'">
                        <Input  show-word-limit  v-model="start_place"   type='text' class="ipt"  placeholder="请输入发生地址"    />
                    </div>                                            
                </li>
                <!-- 安葬地 -->
                <li  v-if="lm_check == 'rw'">
                    <div class='list_title'> <span v-if="out_btn_num == 0" class="cRed">*</span> 安葬地 :</div> 
                    <div class="list_con">
                        <Input :maxlength="20" show-word-limit v-model="end_place"   type='text' class="ipt"  placeholder="请输入安葬地"    />
                    </div>                                            
                </li>
                <!-- 死亡原因 -->
                <li v-if="lm_check == 'rw'">
                    <div class='list_title'> <span v-if="out_btn_num == 0" class="cRed">*</span> 死亡原因 :</div> 
                    <div class="list_con">
                        <Input   v-model="causeOfDeath"   :maxlength="10" show-word-limit  type='text' class="ipt"  placeholder="请输入死亡原因"    />
                        
                    </div>                                            
                </li>
                <!-- 排序 -->
                <li>
                    <div class='list_title'> <span v-if="out_btn_num == 0" class="cRed">*</span> 排序 :</div> 
                    <div class="list_con">
                        <InputNumber   v-model="out_model3" :min="0" :max="999999999"  type='number' class="ipt"  placeholder="请输入排序"    />
                    </div>                                            
                </li>
                <!-- 逝者信息 -->
                <li>
                    <div class='list_title' v-if="lm_check == 'rw'"> <span v-if="out_btn_num == 0" class="cRed">*</span> 逝者信息 :</div> 
                    <div class="list_con"   v-if="lm_check == 'rw'">
                        <Input :maxlength="500" show-word-limit v-model="profile" :rows="4"   type='textarea' class="ipt"  placeholder="请输入逝者信息"    />
                    </div>   
                    <!-- 事件详情 -->
                    <div class='list_title' v-if="lm_check == 'sj'"> <span v-if="out_btn_num == 0" class="cRed">*</span> 事件详情 :</div> 
                    <div class="list_con"   v-if="lm_check == 'sj'">
                        <Input :maxlength="500" show-word-limit v-model="profile" :rows="4"   type='textarea' class="ipt"  placeholder="请输入事件详情"    />
                    </div>   

                                 
                </li>
                <!-- 上传头像 -->
                <li>
                    <div class='list_title' v-if="lm_check == 'rw'"> <span v-if="out_btn_num == 0" class="cRed">*</span> 上传头像 :</div> 
                    <div class='list_title' v-if="lm_check == 'sj'"> <span v-if="out_btn_num == 0" class="cRed">*</span> 上传图片 :</div> 
                    <div class="list_con">
                        <cropper @childFun="childFun2"      :data="cropper_data"  ></cropper>         
                    </div>
                                                                
                </li>
                <!-- 选择音乐 -->
                <li>
                    <div class='list_title'> <span v-if="out_btn_num == 0" class="cRed">*</span> 选择音乐 :</div> 
                    <div class="list_con">
                        <Button type='info' icon="ios-musical-notes"  @click="MuBg_btnFun();MuBg_num = '1';MuBg_title = '音乐列表';m_bool = !m_bool">选择音乐</Button>
                    </div>                                            
                </li>
                <!-- 选择背景 -->
                <li>
                    <div class='list_title'> <span v-if="out_btn_num == 0" class="cRed">*</span> 选择背景 :</div> 
                    <div class="list_con">
                        <Button type='info' icon="md-images"  @click="MuBg_btnFun();MuBg_num = '0';MuBg_title = '背景列表';b_bool = !b_bool">选择背景</Button>
                    </div>                                            
                </li>
                <!-- 是否推荐 -->
                <li>
                    <div class='list_title'> <span v-if="out_btn_num == 0" class="cRed">*</span> 推荐状态 :</div>         
                    <div class="list_con">
                        <i-switch class='mSwitch' v-model="out_model4" :true-value="Number(1)" :false-value="Number(0)" @on-change="change_out_isBetter" />
                    </div>                                                
                </li>
                <!-- 是否显示 -->
                <li>
                    <div class='list_title'> <span v-if="out_btn_num == 0" class="cRed">*</span> 显示状态 :</div>         
                    <div class="list_con">
                        <i-switch class='mSwitch' v-model="out_model5" :true-value="Number(0)" :false-value="Number(1)" @on-change="change_out_display" />
                    </div>                                                
                </li>
                <!-- 礼物收费 -->
                <li>
                    <div class='list_title'> <span v-if="out_btn_num == 0" class="cRed">*</span> 礼物收费 :</div>         
                    <div class="list_con">
                        <i-switch class='mSwitch' v-model="out_model7" :true-value="Number(0)" :false-value="Number(1)" @on-change="change_out_isGift" />
                    </div>                                                
                </li>
            </ul>
        </Modal>           
        <!-- 查看纪念堂 -->
        <Modal
            v-model="lookj"
            title="查看纪念堂"
            
            class-name="vertical-center-modal"
            width="820"
            
        >
            <div slot="footer">
                <Button type='primary'  @click='lookj_close'>关闭</Button>
            </div>
            
            <ul class="layout_ul" v-if="lookj" style="height:500px;overflow-y:auto;">
                
                <!-- 姓名 -->
                <li>
                    <div class='list_title' v-if="lm_check == 'rw'">  姓名 :</div> 
                    <div class='list_title' v-if="lm_check == 'sj'">  事件名称 :</div> 
                    <div class="list_con" >
                        <span class="mem_lh" >{{ lookj_val.name }}</span>
                        
                    </div>                                            
                </li>
                <!-- 头像 -->
                <li>
                    <div class='list_title' v-if="lm_check == 'rw'">  头像 :</div> 
                    <div class='list_title' v-if="lm_check == 'sj'">  事件图片 :</div> 
                    <div class="list_con">
                        <img :src="lookj_val.image" style="width:200px;" alt="" >
                    </div>                                            
                </li>
                <!-- 出生死亡时间 -->
                <li>
                    <div class='list_title' v-if="lm_check == 'rw'">  出生时间 :</div> 
                    <div class='list_title' v-if="lm_check == 'sj'">  发生时间 :</div> 
                    <div class="list_con">
                        <span class="mem_lh ">{{lookj_val.dateOfBirth}}</span>
                        <span class="mem_lh rgt"   v-if="lm_check == 'rw'">{{lookj_val.dateOfDeath}}</span>
                        <p class="rgt  fs14  rtxt" v-if="lm_check == 'rw'">死亡时间 :</p>
                    </div>                                            
                </li>
                
                
                <!-- 出生地 -->
                <li>
                    <div class='list_title' v-if="lm_check == 'rw'">  出生地 :</div> 
                    <div class='list_title' v-if="lm_check == 'sj'">  发生地址 :</div> 

                    <div class="list_con">
                        <span class="mem_lh">{{ lookj_val.placeOfBirth}}</span>
                    </div>                                            
                </li>
                <!-- 安葬地 -->
                <li v-if="lm_check == 'rw'">
                    <div class='list_title'>  安葬地 :</div> 
                    <div class="list_con">
                        <span class="mem_lh">{{ lookj_val.burialPlace}}</span>     
                    </div>                                            
                </li>
                <!-- 死亡原因 -->
                <li v-if="lm_check == 'rw'">
                    <div class='list_title'>  死亡原因 :</div> 
                    <div class="list_con">
                        <span class="mem_lh">{{ lookj_val.causeOfDeath}}</span> 
                    </div>                                            
                </li>
                <!-- 多选 -->
                <li>
                    <div class='list_title'>  所属类目 :</div> 
                    <div class="list_con " v-if="lm_check == 'rw'">
                        <span class="mem_lh">{{ lookj_val.typeName2 }}</span>
                    </div>                                            
                    <div class="list_con " v-if="lm_check == 'sj'">
                        <span class="mem_lh">事件</span>
                    </div>                                            
                </li>
                <!-- 性别 -->
                <li v-if="lm_check == 'rw'">
                    <div class='list_title'> <span v-if="out_btn_num == 0"  class="cRed">*</span> 性别 :</div> 
                    <div class="list_con " >
                        <span class="mem_lh" v-if="lookj_val.sex == 1">
                            男
                        </span>
                        <span class="mem_lh" v-if="lookj_val.sex == 2">
                            女
                        </span>
                        <span class="mem_lh" v-if="lookj_val.sex == 0">
                            未知
                        </span>

                    </div>                                            
                </li>
                <!-- 是否推荐 -->
                <li>
                    <div class='list_title'>  是否推荐 :</div>         
                    <div class="list_con">
                        
                        <span class="mem_lh" v-if="lookj_val.isBetter == 1">是</span>
                        <span class="mem_lh" v-if="lookj_val.isBetter == 0">否</span>

                        
                    </div>                                                
                </li>
                <!-- 排序 -->
                <li>
                    <div class='list_title'> <span v-if="out_btn_num == 0"  class="cRed">*</span> 排序 :</div> 
                    <div class="list_con " >
                       
                        <span class="mem_lh ">{{lookj_val.sort}}</span>
                
                    </div>                                            
                </li>
                <!-- 选择音乐  -->
                <li>
                    <div class='list_title'>  选择音乐 :</div> 
                    <div class="list_con">
                        <span class="mem_lh"  >{{ lookj_val.backgroundMusicName}}</span>
                        
                    </div>                                            
                </li>
                <!-- 选择背景  -->
                <li>
                    <div class='list_title'>  选择背景 :</div> 
                    <div class="list_con">
                    
                        <span class="mem_lh "  >{{lookj_val.backgroundImageName}}</span>
                        
                    </div>                                            
                </li>
                <!-- 逝者信息 -->
                <li>
                    <div class='list_title' v-if="lm_check == 'rw'">  逝者信息 :</div> 
                    <div class='list_title' v-if="lm_check == 'sj'">  事件详情 :</div> 
                    <div class="list_con">
                        <!-- <Input disabled  :value="lookj_val.profile" :rows="4"   type='textarea' class="ipt"  placeholder="请输入逝者信息"    /> -->
                        <div class="lookj_txt">{{lookj_val.profile}}</div>
                    </div>                                            
                </li>
                
                
                
                
                <!-- 是否显示 -->
                <!-- <li>
                    <div class='list_title'>  是否显示 :</div>         
                    <div class="list_con">
                        
                        <span class="mem_lh" v-if="lookj_val.display == 1">否</span>
                        <span class="mem_lh" v-if="lookj_val.display == 0">是</span>
                        
                    </div>                                                
                </li> -->
               
            </ul>
        </Modal>           
        <!-- 查看类目  -->
        <Modal
            v-model="lm"
            title="纪念堂类目"
            class-name="vertical-center-modal"
            width="1000"
            >
            <div slot="footer">     
                <Button type='primary'  @click='lookSucc'>关闭</Button>
            </div>
            <div class="my_table bottom20"  >
                    
                <div class="my_search" style="margin-bottom:1px;">
                    
                    <Row class="search_row">  
                        <div  class="search_name">           <!--  0 添加; 1 编辑; 2 删除  -->
                        <Button class="mR5" disabled   type="info"    @click='route="/layout/circle/memorial/m_add";m_btnFun(null,0);' > <Icon type="md-add" />添加</Button>                              
                        </div>
                        
                    </Row>
                    
                </div>
                <Table     border :columns="columns" :data="data" ref='table' >
                    <template slot-scope="{ row, index }" slot="btn" >
                 
                        <span  >
                            <Poptip trigger="hover"   content="编辑">
                                <Button class="padlr5" disabled size="small"  @click='route="/layout/circle/memorial/m_editor";m_btnFun(row,1)'  type="success"      icon="md-open"></Button>
                            </Poptip>
                            <Poptip trigger="hover"  content="删除">
                                <Button class="padlr5"  disabled size="small" @click='route="/layout/circle/memorial/m_del";m_btnFun(row,2)'  type="error"      icon="md-close"></Button>
                            </Poptip>
                        </span>

                    </template>                        
                </Table>
            
            </div>
        </Modal> 

        <!-- 类目弹窗的按钮弹窗 -->
        <Modal
            v-model="m_btn"
            :title="m_title"
            
            class-name="vertical-center-modal"
            width="520"
        >
            <div slot="footer">
                <Button type='text'  @click='m_btnFail'>取消</Button>
                <Button type='primary'  @click='m_btnSucc'>{{m_succ}}</Button>
            </div>
            
            <p  v-if="m_btn_num == 2">确定删除类目吗?</p>
            <ul class="layout_ul" v-if="m_btn_num != 2">
               
                <!-- 分类名称 -->
                <li>
                    <div class='list_title'> <span class="cRed">*</span> 分类名称 :</div> 
                    <div class="list_con">
                        <Input   v-model="m_model1"   type='text' class="ipt"  placeholder="请输入分类名称"    />
                    </div>                                            
                </li>
                <!-- 所属类目 -->
                <li>
                    <div class='list_title'> <span class="cRed">*</span> 所属类目 :</div> 
                    <div class="list_con">
                        <Input   v-model="m_model2"   type='text' class="ipt"  placeholder="请输入所属类目"    />
                    </div>                                            
                </li>
                <!-- 分类排序 -->
                <li>
                    <div class='list_title'> <span class="cRed">*</span> 分类排序 :</div> 
                    <div class="list_con">
                        <Input   v-model="m_model3"   type='number' class="ipt"  placeholder="请输入分类排序"    />
                    </div>                                            
                </li>
                <!-- 分类状态 -->
                <li>
                    <div class='list_title'> <span class="cRed">*</span> 分类状态 :</div>         
                    <div class="list_con">
                        <i-switch class='mSwitch' v-model="m_model4" :true-value="Number(0)" :false-value="Number(1)" @on-change="change_btn" />
                    </div>                                                
                </li>
            </ul>
        </Modal>     

        <!-- 音乐背景弹窗 -->
        <Modal
            v-model="MuBg_btn"
            :title="MuBg_title"
            
            class-name="vertical-center-modal"
            width="1200"
        >
            <div slot="footer">
                <!-- <Button type='text'  @click='MuBg_btn = false;'>取消</Button>
                <Button type='primary'  @click='MuBg_btn = false;music_path = music_v;background_path = background_v'>确定</Button> -->
                <Button type='primary'  @click='MuBg_btn = false;'>关闭</Button>
                
            </div>
            <div v-show="MuBg_num == 1">
                <music @music_val="music_val2" @music_open="music_open2"  :mbm_url="music_url"   :child_bool="m_bool" ></music>
            </div>
            <div v-show="MuBg_num == 0" >
                <background @background_val="background_val2"  @background_open="background_open2" :mbb_url="background_url"  :child_bool="b_bool"></background>
            </div>
            
        </Modal>      
    </div>
    
</template>
<script>
    import { mapState,mapMutations,mapGetters } from 'vuex';
    
    // import cropper from '../../child_vue/vue_cropper.vue';
    
    import {cropper,Background,Music} from '../../child_vue/index.js'

    import aplayer from 'vue-aplayer';

    

    export default {
        name:'memorial',
        data () {
            return {
                m_bool: true,
                b_bool: true,
                token: null,
                route: null,
                guid: null, 
                my_guid:null,
                titles: [],
                title_num: -2,
                // 查看纪念堂
                lookj: false,
                lookj_val: null,
                //内容
                columns1:[],   
                data1:[],
                total: null,
                page:1,
                size: 20,
                //搜索
                search_page:1,
                search_size: 20,
                // 类目 
                columns:[],   
                data:[],
              
                // 主体编辑
                out_url: null,  //场景路径
                
                out_model1:null,  //场景名称
                out_model2:[],  //场景guid
                out_model3:0,  //场景排序
                out_model4:0,  //是否推荐
                out_model5:0,  //是否显示
                out_model6:0,     //收取孝心值
                out_model7:0,     //礼物是否收费
                lm_check: 'rw',   //操作的是人物(rw)还是事件(sj)
                 
                start_time: null,  //生于
                end_time: null,     //卒于
                start_time2: null,  //生于
                end_time2: null,     //卒于

                start_place: null,  //出生地
                end_place: null,    //安葬地

                causeOfDeath: null,        //死亡原因
                profile:null,              //逝者信息
                // 类目编辑
                m_model1:null,  //分类名称
                m_model2:null,  //所属类目
                m_model3:null,  //分类排序
                m_model4:null,  //隐藏分类

                sex:"1",

                profile: null, //逝者信息
                name: null,

                lo: false,
                out_btn: null,  
                out_guid: null,
                out_btn_num: null,
                out_title: null,
                out_succ: null,
                

                lm: false,     //是否弹出类目
                m_btn: false , //类目弹窗的按钮弹窗
                m_guid: null,
                m_btn_num: 0,
                m_title: "添加类目",
                m_succ: "添加",

                // 上传纪念堂
                up_data: null,
                file_name: null,
                file_path: null,

                

                // 上传图片
                        
                cropper_data:{
                    //474*664
                    btn_name: '上传图片',
                    outputType: 'jpeg',  //生成图片格式
                    type:'10',
                    vCropper:'5',
                    enlarge:"3.2", 
                    autoCropWidth:"148.125",
                    autoCropHeight:"207.5"
                },  

                child_val: null,  //child 反馈
                
                MuBg_btn: false,
                MuBg_num: '1',
                MuBg_title: '音乐列表',

                music_url: null,
                background_url: null,
                music_v: null,
                background_v: null,

                music_path: null,
                background_path: null
            }
        },
     
        watch:{
           title_num(val){
               let that = this;
               that.load1();
           }
          
          
        },
        components: {
          aplayer,cropper,Background,Music
        },
        computed: {
            
       
        },
        
        
        methods: {
            
            load(){
              let that = this;
              that.$myAjax.get('admin/service/admin/fame/type?type=1').then( res => {
                  that.titles = res.data.data;
                  
                  that.columns = [
                       {title:'排序',key:'sort',align:'center',width: 80},
                       {title:'名称',key:'title',align:'center',minWidth: 100,ellipsis: true},
                       {title:'所属类目',key:'content',align:'center',minWidth:150},
                       {title:'状态',key:'display',align:'center',width:'110',
                            render: (h, params) => {                          
                              return h('i-switch', {                     
                                      props: {
                                          size: "large",
                                          value: params.row.display,
                                          'true-value': 0,
                                          'false-value': 1
                                      },
                                      on: {
                                          'on-change': (value) => {                                          
                                              that.$myAjax.put(
                                                  'admin/service/admin/fame/type?route=/layout/circle/memorial/editor',
                                                  {
                                                      "guid": params.row.guid,
                                                      "type": 1,
                                                      "display": value
                                                  },
                                                  
                                              ).then(res => {
                                                  that.load();
                                          
                                              }).catch(err=>{
                                                  console.log(err)
                                              })


                                          }
                                      }
                                  },
                                  [h('span', {
                                          slot: "open",
                                          domProps: {
                                              innerHTML: '开启'
                                          }
                                      }),
                                      h('span', {
                                          slot: "close",
                                          domProps: {
                                              innerHTML: '关闭'
                                          }
                                      }),
                                  ]
                              )
                            }

                      },
                      {title:'添加时间',key:'createTime',align:'center',minWidth:110,maxWidth:190},
                      {title:'操作',slot:'btn',align:'center',width:160,fixed: 'right'}
                  ];
                  that.data = res.data.data;
                  that.$data_null.editor(that.data);
                
                  
              })
          },
          load1(){
            
              let that = this;
              let data = {
                  guid: that.guid,
                  page: that.page,
                  size: that.size
                  
              };
              this.$data_null.del(data);
              
              that.$myAjax.get('admin/service/admin/fame'+that.$ajaxNull.get(data)).then( res => {
                  let columns1 = [
                        {title:'排序',key:'sort',align:'center',width: 80},
                        {title:'姓名',key:'name',align:'center',minWidth: 100,maxWidth: 250},
                        {title:'头像',slot:'image',align:'center',width: 73},
                        {title:'逝者信息',key:'profile',minWidth: 200,render:(h,params) => {
                            return h('span',{
                                style:{
                                    
                                }, 
                                domProps:{
                                    title: params.row.profile
                                }
                            },params.row.profile)
                        },align:'center',ellipsis: true},
                        {title:'所属条目',key:'typeName2',minWidth: 130,maxWidth: 160,render:(h,params) => {
                            return h('span',{
                                style:{
                                    
                                }, 
                                domProps:{
                                title: params.row.typeName2
                                }
                            },params.row.typeName2)
                        },align:'center',ellipsis: true},                    
                        {title:'状态',key:'display',align:'center',width:'110',
                            render: (h, params) => {      
                              return h('i-switch', {        
                                      props: {
                                          size: "large",
                                          value: params.row.display ,
                                          'true-value': 0,
                                          'false-value': 1
                                      },
                                      on: {
                                          'on-change': (value) => {                                           
                                              that.$myAjax.put(           
                                                  'admin/service/admin/fame?route=/layout/circle/memorial/editor',
                                                  {
                                                      "guid": params.row.guid,
                                                      "type": 1,
                                                      "display": value
                                                  },
                                                  
                                              ).then(res => {
                                                  that.load1();
                                          
                                              }).catch(err=>{
                                                  console.log(err)
                                              })


                                          }
                                      }
                                  },
                                  [h('span', {
                                          slot: "open",
                                          domProps: {
                                              innerHTML: '开启'
                                          }
                                      }),
                                      h('span', {
                                          slot: "close",
                                          domProps: {
                                              innerHTML: '关闭'
                                          }
                                      }),
                                  ]
                              )
                            }

                        },
                        {title:'礼物',key:'isGift',align:'center',width:'110',
                            render: (h, params) => {      
                              return h('i-switch', {        
                                      props: {
                                          size: "large",
                                          value: params.row.isGift ,
                                          'true-value': 0,
                                          'false-value': 1
                                      },
                                      on: {
                                          'on-change': (value) => {                                           
                                              that.$myAjax.put(           
                                                  'admin/service/admin/fame?route=/layout/circle/memorial/editor',
                                                  {
                                                      "guid": params.row.guid,
                                                      "type": 1,
                                                      "isGift": value
                                                  },
                                                  
                                              ).then(res => {
                                                  that.load1();
                                          
                                              }).catch(err=>{
                                                  console.log(err)
                                              })


                                          }
                                      }
                                  },
                                  [h('span', {
                                          slot: "open",
                                          domProps: {
                                              innerHTML: '收费'
                                          }
                                      }),
                                      h('span', {
                                          slot: "close",
                                          domProps: {
                                              innerHTML: '免费'
                                          }
                                      }),
                                  ]
                              )
                            }

                        },
                        {title:'创建时间',key:'createTime',align:'center',minWidth: 110,maxWidth:220},
                        {title:"操作",slot:"btn",align:"center",width:160,fixed: 'right'},
                  ]; 
                  if(!that.guid){
                      columns1.shift();
                     
                  }

                  if(that.guid == 'better'){
                      columns1.shift();

                      columns1.unshift( {title:'排序',slot:'betterSort',align:'center',width: 110} )
                  }

                  that.columns1 = columns1;



                  that.data1 = res.data.data.list;
                  that.page = res.data.data.pageNum;
                  that.size = res.data.data.pageSize;
                  that.total = res.data.data.total;
                  
                  
                  that.$split(that.data1);
                  that.$data_null.editor(that.data1);

                //   console.log(that.data1)

              })
          },
          
          change_page(){
              this.load1();
          },
          change_size(size){
              this.size = size;
              this.load1();
          },
          
            // 查看 
            out_btnFun2(row){
                let that = this;
                  //判断是提交事件还是人物
                if( row.typeName.indexOf("事件") != -1 ){
                    that.lm_check = 'sj'
                }else{
                    that.lm_check = 'rw'
                }
            
            },
            
            // 人物/事件 中按钮 ,m_btn_num 0 添加，1 编辑 ， 2 删除
            out_btnFun(row,num){
                let that = this;
                
                that.out_btn = true;
                that.out_btn_num = num;
                
                //传给子组件 
                that.background_url = null;
                that.music_url = null;
                
                //点击确认后
                that.music_path = null;
                that.background_path = null;
                
                if(that.out_btn_num != 0){              //判断是提交事件还是人物
                    if( row.typeName.indexOf("事件") != -1 ){
                        that.lm_check = 'sj'
                    }else{
                        that.lm_check = 'rw'
                    }
                }
               

                if(that.out_btn_num == 0){
                    if(that.lm_check == 'rw'){
                        that.out_title = "添加人物";
                    }
                    if(that.lm_check == 'sj'){
                        that.out_title = "添加事件";
                    }
                    
                    that.out_succ = "添加";
                }else if(that.out_btn_num == 1){
                    that.out_guid = row.guid;
                    if(that.lm_check == 'rw'){
                        that.out_title = "编辑人物";
                    }
                    if(that.lm_check == 'sj'){
                        that.out_title = "编辑事件";
                    }
                    
                    that.out_succ = "修改";
                    
                }else if(that.out_btn_num == 2){
                    that.out_guid = row.guid;
                    that.out_title = "提示";
                    that.out_succ = "删除";
                }
                if(num == 0){
                    that.out_model1 = null;
                    that.out_model2 = [];
                    that.out_model3 = null;   //排序
                    that.out_model4 = 0;
                    that.out_model5 = 0;
                    that.out_model6 = null;    //收取孝心值
                    that.out_model7 = 0;    //礼物收费
                    that.child_val = null;

                    that.sex = "1";
                    that.start_time = null;
                    that.end_time = null;
                    that.start_place = null;
                    that.end_place = null;
                    that.causeOfDeath = null;
                    that.profile = null;
                }else if(num == 1){
                    

                    //传给子组件 
                    that.background_url = row.backgroundImagePath;
                    that.music_url = row.backgroundMusicPath;

                    // 输入框
                    that.my_guid = row.guid;
                    that.out_model1 = row.name;
                    that.out_model2 = row.typeGuid.split(",");
                    that.out_model3 = row.sort;
                    that.out_model4 = row.isBetter;
                    that.out_model5 = row.display;
                    that.out_model6 = row.money;
                    that.out_model7 = row.isGift;
                    that.child_val = null;

                    that.sex = row.sex.toString();
                    that.start_time = row.dateOfBirth;
                    that.end_time = row.dateOfDeath;
                    that.start_time2 = row.dateOfBirth;
                    that.end_time2 = row.dateOfDeath;

                    that.start_place = row.placeOfBirth;
                    that.end_place = row.burialPlace;
                    that.causeOfDeath = row.causeOfDeath;
                    that.profile = row.profile;
                }
                
            },
            out_btnFail(){
                this.out_btn = false;
            },
            out_btnSucc(){
                let that = this;
                
                let sort = that.out_model3?JSON.parse(that.out_model3):null;
                let money = that.out_model6?JSON.parse(that.out_model6):null;
               
                let data;
                if(that.lm_check == 'rw'){
                    data = {
                        'name': that.out_model1,
                        'typeGuid': that.out_model2.join(","),
                        'sort': sort,
                        'isBetter': that.out_model4,
                        'display': that.out_model5,
                        'isGift': that.out_model7,
                        'image': null,
                        'sex': that.sex,
                        
                        'dateOfBirth': that.start_time,
                        'dateOfDeath': that.end_time,
                        'placeOfBirth': that.start_place,
                        'burialPlace': that.end_place,
                        'causeOfDeath': that.causeOfDeath,
                        'profile': that.profile,
                        'backgroundImage': that.background_v,
                        'backgroundMusic': that.music_v,
                    }
                    this.$data_null.del(data);
                }else if(that.lm_check == 'sj'){
                    data = {
                        'name': that.out_model1,
                        'typeGuid': "a4ca8383ef3711e99ae19c5c8e7b8156",
                        'sort': sort,
                        'isBetter': that.out_model4,
                        'display': that.out_model5,
                        'isGift': that.out_model7,
                        'image': null,
                        
                        'dateOfBirth': that.start_time,
                        
                        'placeOfBirth': that.start_place,
                        
                        'profile': that.profile,
                        'backgroundImage': that.background_v,
                        'backgroundMusic': that.music_v,
                    }
                    this.$data_null.del(data);
                }
                
                
                

                let bn = that.out_btn_num;
                
                if( bn != 2){
                    if(!data.typeGuid){
                        that.$alert.info('所属类目必选其一');
                        return;
                    }     
                                   
                    if(!that.child_val){  //child_val==false 的时候 不上传 图片
                        data.guid = null;
                        data.image = null; 
                        if(bn == 0){         
                            that.$myAjax.post('admin/service/admin/fame?route=' + that.route,that.$ajaxNull.post(data)).then( res => {
                        
                                if(res.data.code == 1){
                                    that.out_btnFail();
                                    that.load();
                                    that.load1();
                                }
                            })
                        }else if(bn == 1){
                            if(that.lm_check == 'rw'){
                                 let start_num = that.start_time.match(/\//g).length ;
                                 let end_num = that.start_time.match(/\//g).length ;
                                
                                 if( start_num != 4 || end_num != 4 ){
                                     that.$alert.info('请使用正确时间格式');
                                     return;
                                 }
                                 
                            }
                            data.guid = that.out_guid;
                            that.$myAjax.put('admin/service/admin/fame?route=' + that.route,that.$ajaxNull.post(data)).then( res => {
                       
                                if(res.data.code == 1){
                                    that.out_btnFail();
                                    that.load();
                                    that.load1();
                                }
                            })
                        }              
                    }else{
                       
                        that.$upload(
                            that.child_val
                        ).then(res => { 
                            data.guid = null;
                            data.image = res.data.data.name; 
                            if(bn == 0){                     
                                that.$myAjax.post('admin/service/admin/fame?route=' + that.route,that.$ajaxNull.post(data)).then( res => {
                                    if(res.data.code == 1){
                                        that.out_btnFail();
                                        that.load();
                                        that.load1();
                                    }
                                })
                            }else if(bn == 1){
                                data.guid = that.out_guid;
                                that.$myAjax.put('admin/service/admin/fame?route=' + that.route,that.$ajaxNull.post(data)).then( res => {
                       
                                    if(res.data.code == 1){
                                        that.out_btnFail();
                                        that.load();
                                        that.load1();
                                    }
                                })
                            }             
                            
                            
                        }).catch(res => {

                        });
                    }  
                }else if(bn == 2){
                    data.guid = that.out_guid;
                    that.$myAjax.delete('admin/service/admin/fame?route=' + that.route+'&guid='+that.out_guid).then( res => {
                        if(res.data.code == 1){
                            that.out_btnFail();
                            that.load();
                            that.load1();
                        }
                    })
                }
               
            },
            // 搜索名称
            nameFun(){
                let that = this;
                let data = {
                  name: that.name,
                  page: that.search_page,
                  size: that.search_size,
                  
                };
                this.$data_null.del(data);
                if(that.name){
                    that.$myAjax.get('admin/service/admin/fame/search/name'+that.$ajaxNull.get(data)).then( res => {
                        that.data1 = res.data.data.list;
                        that.page = res.data.data.pageNum;
                        that.size = res.data.data.pageSize;
                        that.total = res.data.data.total;
                    })
                }else{
                    that.load1();
                }
                
                
            },
            
           change_out_isBetter(bool){
               this.out_model4 = bool;
              
            },
           change_out_display(bool){
               this.out_model5 = bool;
               
            },
           change_out_isGift(bool){
               this.out_model7 = bool;
               
            },
            //   类目
            change_btn(bool){
               this.m_model4 = bool;
               
            },
            //   查看类目
           lookFun(){
               this.lm = true;
           },
            lookSucc(){
               this.lm = false;
            },
            //类目 中按钮 ,m_btn_num 0 添加，1 编辑 ， 2 删除
            m_btnFun(row,num){
                let that = this;
                
                that.m_btn = true;
                that.m_btn_num = num;
                
                if(that.m_btn_num == 0){
                    that.m_title = "添加类目";
                    that.m_succ = "添加";
                }else if(that.m_btn_num == 1){
                    that.m_guid = row.guid;
                    that.m_title = "编辑类目";
                    that.m_succ = "修改";
                    
                }else if(that.m_btn_num == 2){
                    that.m_guid = row.guid;
                    that.m_title = "提示";
                    that.m_succ = "删除";
                }
                if(num == 0){
                    that.m_model1 = null;
                    that.m_model2 = null;
                    that.m_model3 = null;
                    that.m_model4 = 0;
                }else if(num == 1){
                    that.m_model1 = row.title;
                    that.m_model2 = row.content;
                    that.m_model3 = row.sort;
                    that.m_model4 = row.display;
                }
            },
            m_btnFail(){
                this.m_btn = false;
            },
            m_btnSucc(){
                let that = this;
                let data = {
                    title: that.m_model1,
                    content: that.m_model2,
                    sort: that.m_model3,
                    display: that.m_model4,
                }
                this.$data_null.del(data);
                if(that.m_btn_num == 0){
                    that.$myAjax.post('admin/service/admin/fame/type?route=' + that.route,that.$ajaxNull.post(data)).then( res => {
                        if(res.data.code == 1){
                            that.m_btnFail();
                            that.load();
                            that.load1();
                        }
                    })
                }else if(that.m_btn_num == 1){
                    
                    let data1 = data;
                    data1.guid = that.m_guid;
                    that.$myAjax.put('admin/service/admin/fame/type?route=' + that.route,that.$ajaxNull.post(data1)).then( res => {
                        if(res.data.code == 1){
                            that.m_btnFail();
                            that.load();
                            that.load1();
                        }
                    })
                }else if(that.m_btn_num == 2){
                    data.guid = that.m_guid;
                    that.$myAjax.delete('admin/service/admin/fame/type?route=' + that.route +'&guid='+ that.m_guid ).then( res => {
                        if(res.data.code == 1){
                            that.m_btnFail();
                            that.load();
                            that.load1();
                        }
                    })
                }
            },
            

            //上传音频
            up_succ(opt){
                let that = this;
                that.file_name = opt.data.name;
                that.file_path = opt.data.path;
            },

            // 上传图片反馈
            childFun2 (data){
                let that = this;
                that.child_val = data.pic_url;          
                
            },

            // 出生日期
            start_timeFun(time){
                let that = this;    
                that.start_time = time;
            },
            // 死亡日期
            end_timeFun(time){
                let that = this;
                that.end_time = time;
            },
            //选择音乐和选择背景
            MuBg_btnFun(){
                let that = this;
                
                that.MuBg_btn = true;

            },


            music_val2(opt){
                this.music_v = opt;
                // console.log(this.music_v);
            },
            music_open2(opt){
                this.MuBg_btn = opt;
                // console.log(111,this.MuBg_btn)
                
            },
            background_val2(opt){
                this.background_v = opt;
                // console.log(555,this.background_v);
            },
            background_open2(opt){
                this.MuBg_btn = opt;
                // console.log(555,this.background_v);
            },
            lookj_close(){
                this.lookj = false;
            },

            better_sortFun(row){   //修改推荐排序
                let that = this;
                that.$myAjax.put(           
                    'admin/service/admin/fame?route=/layout/circle/memorial/editor',
                    {
                        "guid": row.guid,
                        "type": 1,
                        "betterSort": row.betterSort
                    },
                    
                ).then(res => {
                    that.load1();
            
                }).catch(err=>{
                    console.log(err)
                })   
            }
          
        },
        mounted: function(){
           let that = this;
           that.my_guid = that.$store.state.guid;
           
           that.token = that.$store.state.token;
           that.load();
           that.load1();
           
        }
    }
</script>
<style scoped>
    .rtxt{
        height:32px;
        line-height:32px;
        padding-right:10px
    }
    .mem_lh{
        display: line-block;
        height: 32px;
        line-height: 32px;
    }
    .lookj_txt{
        height: 180px;
        width: 100%;
        line-height: 18px;
        border: 1px solid #e4e4e4;
        padding: 10px;
        overflow: hidden;
        overflow-y: auto;
        word-wrap: break-word;
        word-break: normal; 
        text-indent:2em;
        border-radius: 3px;
    }
    .con_content{
        position: relative;
        width: 100%;
        height: auto;
    }   
    .tx_pic{
        width:100%;
        margin-top:5px;
        border-radius:2px;
    } 
</style>